/**
 *
 *
 *
 */
export const getIndex = (container) => {
    return container?.parentElement?.parentElement?.getAttribute("data-index") || 0;
};

/**
 *
 *
 *
 */
export const getFeatureOrder = (container) => {
    return container.parentElement?.parentElement?.getAttribute("data-feature-order") || "99";
};

/**
 *
 *
 *
 */
export const getAggregationFeatureLabels = (container) => {
    const aggregationFeatureLabels = container.parentElement?.parentElement?.getAttribute("data-feature-tracking-labels");
    if (!aggregationFeatureLabels) {
        return {};
    }
    return JSON.parse(aggregationFeatureLabels);
};

/**
 *
 *
 *
 */
export const getNextPiTrackingLabels = (container) => {
    const nextPiTrackingLabels = container.parentElement?.parentElement?.getAttribute("data-next-pi-tracking-labels");
    if (!nextPiTrackingLabels) {
        return {};
    }
    return JSON.parse(nextPiTrackingLabels);
};
